// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1PvO7","title":"BackImages_title__3QXmL","images":"BackImages_images__2GkJW"};